import {
  Button,
  ContextGuideContext,
  FormControlSizes,
  HStack,
  Icon,
  IconName,
  Text,
  getIconSize,
  type ContextGuideID,
} from '@talos/kyoko';
import { useCallback, useContext } from 'react';

export function GuideButton({ guideID }: { guideID: ContextGuideID }) {
  const { setGuide, getGuide } = useContext(ContextGuideContext);
  const toggleHelpGuide = useCallback(() => {
    const newValue = !getGuide(guideID);
    setGuide(guideID, newValue);
  }, [getGuide, setGuide, guideID]);

  const isGuideEnabled = getGuide(guideID);

  return (
    <Button
      size={FormControlSizes.Small}
      onClick={toggleHelpGuide}
      ghost={!isGuideEnabled}
      data-testid="toggle-guide-button"
    >
      <HStack gap="spacing2">
        <Icon
          size={getIconSize(FormControlSizes.Small)}
          icon={IconName.LightBulb}
          color={isGuideEnabled ? 'colors.blue.lighten' : 'colorTextSubtle'}
        />
        <Text color={isGuideEnabled ? 'colorTextImportant' : 'colorTextSubtle'}>
          {isGuideEnabled ? 'Hide' : 'Show'} Guide
        </Text>
      </HStack>
    </Button>
  );
}
